import { useCallback, useContext } from 'react';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import { SearchLoadingDispatchContext, SearchResultsDispatchContext } from '@/containers/WorkspaceGlobalSearch/Context';
import type { WorkspaceSearchFull } from '@trinity/chat';

export default function useSearchFetchFiles() {
  const setResults = useContext(SearchResultsDispatchContext);
  const setLoading = useContext(SearchLoadingDispatchContext);

  const apiClient = useChatApiClient();

  const files = useCallback(async ({ filters, size }: FetchData) => {
    const result = await apiClient.workspacesGlobalSearch.files({
      filters,
      size,
    });

    if (result) {
      setResults(prev => ({
        ...prev,
        files: result,
      }));
    }
  }, [apiClient, setResults]);

  const fetch = useCallback(({ filters, size }: FetchData) => {
    setLoading(prev => ({ ...prev, files: { ...prev.files, loading: true } }));
    Promise.all([
      new Promise<void>(resolve => setTimeout(() => resolve(), 250)),
      files({ filters, size }),
    ])
      .then(() => {
        setLoading(prev => ({ ...prev, files: { loading: false } }));
      });
  }, [files, setLoading]);

  return fetch;
}

export { useSearchFetchFiles };

type FetchData = {
  filters: WorkspaceSearchFull.File.Filters;
  size: number;
};